import { FeatureType, LanguageOption } from '../types';

export { MOCK_PARTICIPANTS, MOCK_PARTICIPANTS_WITH_DISTANCE } from './mocks/participants'
export { MOCK_POIS } from './mocks/pois'
export { MOCK_TENANT } from './mocks/tenant'
export { POI_CATEGORIES, CATEGORY_COLORS, type POICategoryId } from './poiCategories';
export {
    PLAN_CONFIGURATIONS,
    getPlanConfiguration,
    type PlanConfiguration
} from './subscription-plans';

export const UPDATE_FREQUENCIES = {
    realtime: 3e4, // 30s - per guide/staff
    frequent: 6e4,  // 60s - per tour guidati
    normal: 18e4,   // 3min - default visitatori
    occasional: 3e5 // 5min - per camping/free roaming
};

export const MAP_TILES = [
    {
        label: "Light all",
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        meta: [
            {
                name: "OpenStreetMap",
                url: "https://www.openstreetmap.org"
            }
        ]
    },
    {
        label: "Dark all",
        url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CartoDB</a>',
        meta: [
            {
                name: "OpenStreetMap",
                url: "https://www.openstreetmap.org"
            },
            {
                name: "CartoDB",
                url: "https://carto.com/attribution"
            }
        ]
    },
    {
        label: "Light no labels",
        url: "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CartoDB</a>',
        meta: [
            {
                name: "OpenStreetMap",
                url: "https://www.openstreetmap.org"
            },
            {
                name: "CartoDB",
                url: "https://carto.com/attribution"
            }
        ]
    },
    {
        label: "Satellite",
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        attribution: '&copy; <a href="https://www.esri.com/">Esri</a>, Maxar, Earthstar Geographics, and the GIS User Community',
        meta: [
            {
                name: "Esri",
                url: "https://www.esri.com/"
            },
            {
                name: "Maxar",
                url: "https://www.maxar.com/"
            },
            /* {
                name: "Earthstar Geographics",
                url: "https://www.earthstargeographics.com/"
            },
            {
                name: "GIS User Community",
                url: "https://www.gisuser.com/"
            } */
        ]
    }
]

// Temi DaisyUI disponibili
export const AVAILABLE_THEMES = [
    "light",
    "dark",
    "cupcake",
    "bumblebee",
    "emerald",
    "corporate",
    "synthwave",
    "retro",
    "cyberpunk",
    "valentine",
    "halloween",
    "garden",
    "forest",
    "aqua",
    "lofi",
    "pastel",
    "fantasy",
    "wireframe",
    "black",
    "luxury",
    "dracula",
    "cmyk",
    "autumn",
    "business",
    "acid",
    "lemonade",
    "night",
    "coffee",
    "winter",
    "dim",
    "nord",
    "sunset",
    "caramellatte",
    "abyss",
    "silk"
] as const;

export const AVAILABLE_DARK_THEMES = [
    'dark',
    'synthwave',
    'halloween',
    'forest',
    'aqua',
    'black',
    'luxury',
    'dracula',
    'business',
    'night',
    'coffee',
    'dim',
    'sunset',
    'abyss'
] as const;

// Lingue disponibili
export const AVAILABLE_LANGUAGES: LanguageOption[] = [
    { code: 'it', label: 'Italiano' },
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
];

export const AVAILABLE_FEATURES: FeatureType[] = [
    'custom-map',
    'multi-language',
    'gateway',
    'analytics',
    'custom-service',
    'white-label',
    'device-tracking'
];
